import React from 'react';
import '../styles/Service.css';
import { Fragment } from 'react';
import s1 from '../components/images/si-1.png';
import s2 from '../components/images/si-2.png';
import s3 from '../components/images/si-3.png';
import s4 from '../components/images/si-4.png';
import s5 from '../components/images/si-5.png';
import s6 from '../components/images/si-6.png';

const services = [
  {
    id: 1,
    image: s1,
    title: 'ReactJS & React Native Development',
    description: 'Specializing in developing dynamic and high-performance applications using ReactJS and React Native.',
  },
  {
    id: 2,
    image: s2,
    title: 'Responsive Web Design',
    description: 'Designing and developing websites that adapt beautifully to any screen size for a consistent user experience.',
  },
  {
    id: 3,
    image: s3,
    title: 'UX/UI Designing',
    description: 'Focused on creating intuitive and visually appealing user interfaces that enhance user satisfaction and usability.',
  },
  {
    id: 4,
    image: s4,
    title: 'Website Maintenance & Updates',
    description: 'Offering comprehensive website maintenance services, including regular updates, security checks, and performance optimizations.',
  },
  {
    id: 5,
    image: s5,
    title: 'Java Application Development',
    description: 'Building reliable and high-performance Java applications tailored to meet specific business requirements.',
  },
  {
    id: 6,
    image: s6,
    title: 'Technical Writing & Documentation',
    description: 'Providing clear and concise technical writing and documentation services to effectively communicate complex information.',
  },
];

const Services = () => {
  return (
    <Fragment>
      <div className='service'>
      <center ><h1 className='m-heading'>My <span className='m-span'>Services</span></h1>
      <p className='p' style={{fontSize:"15px"}} >Those are services where i can deliver Quality output in a given time</p></center>
        <div className='services-container'>
          {services.map((service) => (
            <div key={service.id} className='service-item'>
              <img src={service.image} className='service-image' alt={service.title} />
              <h4 className='service-description'>{service.title}</h4>
              <p className='service-para'>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default Services;
